import type { PublicIncidentSummary } from "@/v2-status-client/status/status.types"
import StatusSection from "@/v2-status-client/status/section/StatusSection"
import StatusIncidentGroup from "@/v2-status-client/status/incident/StatusIncidentGroup"
import { groupByDate } from "@/v2-status-client/status/incident/status.incident.utils"

export type StatusIncidentListProps = {
  incidents: PublicIncidentSummary[]
}

// "Recent incidents" section. Empty state is a friendly blank --
// a 30-day rolling list is expected to be empty most of the time
// for a healthy platform, so this isn't a fallback or error case.
function StatusIncidentList(props: Readonly<StatusIncidentListProps>) {
  const { incidents } = props

  if (incidents.length === 0) {
    return (
      <StatusSection title="Recent incidents" aside="last 30 days">
        <p className="m-0 text-sm text-muted-foreground">
          No incidents reported in the last 30 days.
        </p>
      </StatusSection>
    )
  }

  const groups = groupByDate(incidents)
  return (
    <StatusSection title="Recent incidents" aside="last 30 days">
      <ol className="flex flex-col gap-3 list-none m-0 p-0 pl-4">
        {groups.map((g) => (
          <StatusIncidentGroup key={g.dateLabel} group={g} />
        ))}
      </ol>
    </StatusSection>
  )
}

export default StatusIncidentList
